import "./LoaderDark.css";
import React from "react";

function LoaderDark() {
  return (
    <>
      <div className="loader-container">
        <div className="loader-dark"></div>
      </div>
    </>
  );
}

export default LoaderDark;
